import React, { Component } from 'react';
import { ModalHeader, ModalBody, Alert, Button } from 'reactstrap';

import EntityContainer from './EntityContainer';
import Picker from './Picker';

const INITIAL_STATE = {
  showAlert: false,
  cardData: null,
};

export default class ServiceModal extends Component {
  state = INITIAL_STATE;

  componentDidUpdate(prevProps, prevState) {
    let prevId = prevState.cardData ? prevState.cardData.id : '';
    let currentId = this.state.cardData ? this.state.cardData.id : '';

    if (this.props.theme === 'lodges') {
      if (prevId !== currentId) {
        const elmY = document.querySelector('#trek-lodge-add-alert');
        elmY.scrollIntoView(true);
      }
    }
  }

  render() {
    const { toggle, patchInfo, route, date, theme } = this.props;
    const { showAlert, cardData } = this.state;
    const dropDownValues = this.resolveDropdownOptions();
    return (
      <div className="modal-wrap">
        <ModalHeader toggle={toggle}>
          <Picker value={theme} onChange={this.changeEntityType} options={dropDownValues} />
        </ModalHeader>
        <ModalBody>
          <div className="lodge-holder">
            {showAlert && (
              <Alert color="primary" className="text-center" id="trek-lodge-add-alert">
                <p>
                  UH-OH! You already have one lodge added to this place. Since you will be
                  staying at only one, adding this will replace your previous lodge.
                </p>
                <p>
                  {' '}
                  Do you want to replace it with <strong>{cardData.name}</strong>?
                </p>
                <Button color="success" onClick={this.addLodge}>
                  Yes, replace the old one
                </Button>{' '}
                <Button color="primary" onClick={this.closeAlert}>
                  No, I came here by mistake
                </Button>{' '}
              </Alert>
            )}
            {/* Display all entities chosen from drop down */}
            {theme === 'lodges' && (
              <EntityContainer
                placeId={patchInfo.placeId}
                placeName={patchInfo.placeName}
                cardsArray={route.posters}
                openAlert={this.openAlert}
                theme={theme}
                dayDate={date}
              />
            )}
            {theme === 'attractions' && (
              <EntityContainer
                placeId={patchInfo.placeId}
                placeName={patchInfo.placeName}
                cardsArray={route.posters}
                theme={theme}
                dayDate={date}
              />
            )}
            {theme === 'sidetrips' && (
              <EntityContainer
                placeId={patchInfo.placeId}
                placeName={patchInfo.placeName}
                cardsArray={route.posters}
                theme={theme}
                dayDate={date}
              />
            )}
            {theme === 'places' && (
              <EntityContainer
                placeId={patchInfo.placeId}
                placeName={patchInfo.placeName}
                cardsArray={route.posters}
                theme={theme}
                dayDate={date}
              />
            )}
            {theme === 'sightings' && (
              <EntityContainer
                placeId={patchInfo.placeId}
                placeName={patchInfo.placeName}
                cardsArray={route.posters}
                theme={theme}
                dayDate={date}
              />
            )}
            {theme === 'flights' && (
              <EntityContainer
                placeId={patchInfo.placeId}
                placeName={patchInfo.placeName}
                cardsArray={route.posters}
                theme={theme}
                dayDate={date}
              />
            )}
          </div>
        </ModalBody>
      </div>
    );
  }

  resolveDropdownOptions = () => {
    const { routeLength, route } = this.props;
    const isLastItem = Boolean(this.props.patchInfo.index === routeLength - 1);
    // const hasFlights = route["is_flight_available"];
    // const hasFlights = true;
    // const hasPlaces = route.segment_type === "path" ? true : false;
    const hasSideTrips = route.segment_type === 'point' ? true : false;
    const hasFlights = route.segment_type === 'path' ? true : false;
    var values = [
      isLastItem && 'lodges',
      'attractions',
      'sightings',
      hasFlights && 'flights',
      // hasPlaces && 'places',
      hasSideTrips && 'sidetrips',
    ];
    var dropDownValues = values.filter(option => option);
    return dropDownValues;
  };

  changeEntityType = nextEntityType => {
    this.setState(INITIAL_STATE);
    this.props.changeServiceModalTheme({ nextEntityType });
  };

  addLodge = () => {
    const { addToDay, theme } = this.props;
    const { cardData } = this.state;
    addToDay({ cardData, theme });
    this.setState({
      showAlert: !this.state.showAlert,
    });
  };

  openAlert = cardData => {
    this.setState({
      showAlert: true,
      cardData: cardData,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };
}



// WEBPACK FOOTER //
// ./src/screens/Trek/ServiceModal/ServiceModal.js